export const GET_PROJECT_LIST = "projects";
export const GET_PROJECT_TEAMS = projectName => `projects/teams/${projectName}`;
export const GET_PROJECT_DETAIL = id => `projects/${id}`;
export const GET_PROJECT_CHANNELS = projectName => `projects/teamsChannel/${projectName}`;
